/**
 * Vendor filter for desktop header search bar (modal opens via on:click in Liquid).
 */

const VENDOR_STORAGE_KEY = 'header-search-vendor';

function persistHeaderVendor() {
  const select = document.querySelector('.header-search-global [data-vendor-filter]');
  if (!(select instanceof HTMLSelectElement) || !select.value.trim()) {
    sessionStorage.removeItem(VENDOR_STORAGE_KEY);
    return;
  }
  sessionStorage.setItem(VENDOR_STORAGE_KEY, select.value.trim());
}

function notifyVendorChange() {
  persistHeaderVendor();
  window.dispatchEvent(new CustomEvent('header-vendor-change'));
}

function initHeaderGlobalSearch() {
  const select = document.querySelector('.header-search-global [data-vendor-filter]');
  if (select instanceof HTMLSelectElement) {
    select.addEventListener('change', notifyVendorChange);
  }

  document.querySelectorAll('.header-search-global-trigger').forEach((trigger) => {
    trigger.addEventListener('click', persistHeaderVendor, true);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderGlobalSearch);
} else {
  initHeaderGlobalSearch();
}

document.addEventListener('shopify:section:load', initHeaderGlobalSearch);
